import { useState, useEffect, useCallback } from 'react';
import { useData } from '../../shared/contexts/DataContext'; //
import { processRawData } from './distributionUtils'; //

const useDistributionState = (typeFromUrl, subTypeFromUrl) => { // Accept URL params
    const rawData = useData(); //

    const [processedData, setProcessedData] = useState({
        synthesisMethods: [], //
        substanceTypes: [], //
        stats: { //
            totalProducts: 0, totalSubTypes: 0, topSubstanceType: 'N/A', //
            topSubstanceTypeCount: 0, biologicallyCount: 0, chemicallyCount: 0, topSubTypes: [] //
        }
    });

    // These states are now primarily for feeding the correct data to views based on URL
    const [currentView, setCurrentView] = useState('overview'); //
    const [selectedTypeData, setSelectedTypeData] = useState(null); // Stores the object for the selected type
    const [subTypeDataForView, setSubTypeDataForView] = useState([]); // Data for TypeView chart
    const [selectedProducts, setSelectedProducts] = useState([]); // Data for SubTypeView list


    // Process data when rawData changes
    useEffect(() => {
        const result = processRawData(rawData); //
        setProcessedData(result); //
    }, [rawData]); //

    useEffect(() => {
        if (!typeFromUrl) {
            setCurrentView('overview');
            setSelectedTypeData(null);
            setSubTypeDataForView([]);
            setSelectedProducts([]);
        } else {
            const typeInfo = processedData.substanceTypes.find(t => t.name === typeFromUrl);
            if (typeInfo) {
                setSelectedTypeData(typeInfo);
                const subTypeChartData = Object.entries(typeInfo.subTypes || {}).map(([name, data]) => ({
                    name,
                    value: data.count,
                })).sort((a, b) => b.value - a.value);
                setSubTypeDataForView(subTypeChartData);

                if (!subTypeFromUrl) {
                    setCurrentView('type');
                    setSelectedProducts([]);
                } else {
                    if (typeInfo.subTypes && typeInfo.subTypes[subTypeFromUrl]) {
                        const products = typeInfo.subTypes[subTypeFromUrl].products || [];
                        setSelectedProducts(products);
                        setCurrentView('subtype');
                    } else {
                        // Invalid subtype, potentially navigate to type view or show error
                        setCurrentView('type'); // Fallback to type view
                        setSelectedProducts([]);
                        console.warn(`Subtype '${subTypeFromUrl}' not found under type '${typeFromUrl}'`);
                    }
                }
            } else {
                // Invalid type, potentially navigate to overview or show error
                setCurrentView('overview'); // Fallback to overview
                setSelectedTypeData(null);
                setSubTypeDataForView([]);
                setSelectedProducts([]);
                console.warn(`Type not found: ${typeFromUrl}`);
            }
        }
    }, [typeFromUrl, subTypeFromUrl, processedData.substanceTypes]);


    return {
        currentView,
        selectedType: typeFromUrl, // Pass URL param directly
        selectedSubType: subTypeFromUrl, // Pass URL param directly
        selectedTypeData, // Actual data object for the selected type
        subTypeDataForView,
        selectedProducts,
        synthesisMethods: processedData.synthesisMethods, //
        substanceTypes: processedData.substanceTypes, //
        stats: processedData.stats, //
        rawData: rawData, //
    };
};

export default useDistributionState;